module.exports = __webpack_public_path__ + "img/der.8dea617c.jpg";